import { render, staticRenderFns } from "./HeroModule.vue?vue&type=template&id=2d0bed9d&scoped=true&"
import script from "./HeroModule.vue?vue&type=script&lang=js&"
export * from "./HeroModule.vue?vue&type=script&lang=js&"
import style0 from "./HeroModule.vue?vue&type=style&index=0&id=2d0bed9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0bed9d",
  null
  
)

export default component.exports